export default __webpack_public_path__ + "static/media/bg.a6e55be7.png";